import type {
  OnlineMeetingProvider,
  ScheduleRequestUpdate
} from "@gettactic/api";

type OnlineMeetingSelection =
  | { provider: OnlineMeetingProvider | null }
  | null
  | undefined;

/**
 * Resolves the `online_meeting` field of a schedule update request from the reserve
 * form selection, returning `undefined` when the request must omit the field.
 */
export function resolveOnlineMeetingUpdate(
  selection: OnlineMeetingSelection,
  previousProvider: OnlineMeetingProvider | null
): ScheduleRequestUpdate["online_meeting"] | undefined {
  // The user explicitly turned off the online meeting
  if (selection === null) {
    return null;
  }

  const provider = selection?.provider ?? null;
  if (provider && provider !== previousProvider) {
    return { provider };
  }

  return undefined;
}
